/* eslint-disable */
// @ts-nocheck
// source: internal/question_input_value.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
goog.exportSymbol('proto.worklayer.internal.v1.BoolInputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DateInputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DocumentsInputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.InputValue.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.NumberFormat', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.NumericInputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Question', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SelectInputValue', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SelectInputValue.Multi', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SelectInputValue.SelectionCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SelectInputValue.Single', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SelectOption', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.TextInputValue', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Question = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Question.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Question, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Question.displayName = 'proto.worklayer.internal.v1.Question';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.NumberFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.NumberFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.NumberFormat.displayName = 'proto.worklayer.internal.v1.NumberFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SelectOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SelectOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SelectOption.displayName = 'proto.worklayer.internal.v1.SelectOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.InputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.InputValue.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.InputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.InputValue.displayName = 'proto.worklayer.internal.v1.InputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BoolInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.BoolInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BoolInputValue.displayName = 'proto.worklayer.internal.v1.BoolInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.TextInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.TextInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.TextInputValue.displayName = 'proto.worklayer.internal.v1.TextInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.NumericInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.NumericInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.NumericInputValue.displayName = 'proto.worklayer.internal.v1.NumericInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SelectInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.SelectInputValue.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.SelectInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SelectInputValue.displayName = 'proto.worklayer.internal.v1.SelectInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SelectInputValue.Single = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SelectInputValue.Single, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SelectInputValue.Single.displayName = 'proto.worklayer.internal.v1.SelectInputValue.Single';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SelectInputValue.Multi = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SelectInputValue.Multi.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SelectInputValue.Multi, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SelectInputValue.Multi.displayName = 'proto.worklayer.internal.v1.SelectInputValue.Multi';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DateInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DateInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DateInputValue.displayName = 'proto.worklayer.internal.v1.DateInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DocumentsInputValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.DocumentsInputValue.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.DocumentsInputValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DocumentsInputValue.displayName = 'proto.worklayer.internal.v1.DocumentsInputValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.displayName = 'proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Question.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Question.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Question.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Question} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Question.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    question: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    format: (f = msg.getFormat()) && proto.worklayer.internal.v1.NumberFormat.toObject(includeInstance, f),
    multi: (f = msg.getMulti()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.worklayer.internal.v1.SelectOption.toObject, includeInstance),
    answer: (f = msg.getAnswer()) && proto.worklayer.internal.v1.InputValue.toObject(includeInstance, f),
    collectTime: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    disallowFuture: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    disallowPast: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Question}
 */
proto.worklayer.internal.v1.Question.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Question;
  return proto.worklayer.internal.v1.Question.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Question} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Question}
 */
proto.worklayer.internal.v1.Question.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.NumberFormat;
      reader.readMessage(value,proto.worklayer.internal.v1.NumberFormat.deserializeBinaryFromReader);
      msg.setFormat(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setMulti(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.SelectOption;
      reader.readMessage(value,proto.worklayer.internal.v1.SelectOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.InputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.InputValue.deserializeBinaryFromReader);
      msg.setAnswer(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCollectTime(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisallowFuture(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisallowPast(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Question.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Question.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Question} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Question.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFormat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.NumberFormat.serializeBinaryToWriter
    );
  }
  f = message.getMulti();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.worklayer.internal.v1.SelectOption.serializeBinaryToWriter
    );
  }
  f = message.getAnswer();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.worklayer.internal.v1.InputValue.serializeBinaryToWriter
    );
  }
  f = message.getCollectTime();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDisallowFuture();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getDisallowPast();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Question.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string question = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Question.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Question.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue description = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Question.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
*/
proto.worklayer.internal.v1.Question.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional NumberFormat format = 5;
 * @return {?proto.worklayer.internal.v1.NumberFormat}
 */
proto.worklayer.internal.v1.Question.prototype.getFormat = function() {
  return /** @type{?proto.worklayer.internal.v1.NumberFormat} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.NumberFormat, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.NumberFormat|undefined} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
*/
proto.worklayer.internal.v1.Question.prototype.setFormat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.clearFormat = function() {
  return this.setFormat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.hasFormat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue multi = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.worklayer.internal.v1.Question.prototype.getMulti = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
*/
proto.worklayer.internal.v1.Question.prototype.setMulti = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.clearMulti = function() {
  return this.setMulti(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.hasMulti = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated SelectOption options = 7;
 * @return {!Array<!proto.worklayer.internal.v1.SelectOption>}
 */
proto.worklayer.internal.v1.Question.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.SelectOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.SelectOption, 7));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.SelectOption>} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
*/
proto.worklayer.internal.v1.Question.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.worklayer.internal.v1.SelectOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SelectOption}
 */
proto.worklayer.internal.v1.Question.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.worklayer.internal.v1.SelectOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional InputValue answer = 8;
 * @return {?proto.worklayer.internal.v1.InputValue}
 */
proto.worklayer.internal.v1.Question.prototype.getAnswer = function() {
  return /** @type{?proto.worklayer.internal.v1.InputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.InputValue, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.InputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
*/
proto.worklayer.internal.v1.Question.prototype.setAnswer = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.clearAnswer = function() {
  return this.setAnswer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.hasAnswer = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool collect_time = 9;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.getCollectTime = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setCollectTime = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool disallow_future = 10;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.getDisallowFuture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setDisallowFuture = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool disallow_past = 11;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Question.prototype.getDisallowPast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Question} returns this
 */
proto.worklayer.internal.v1.Question.prototype.setDisallowPast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.NumberFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.NumberFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.NumberFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.NumberFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    places: jspb.Message.getFieldWithDefault(msg, 1, 0),
    type: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.NumberFormat}
 */
proto.worklayer.internal.v1.NumberFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.NumberFormat;
  return proto.worklayer.internal.v1.NumberFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.NumberFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.NumberFormat}
 */
proto.worklayer.internal.v1.NumberFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlaces(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.NumberFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.NumberFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.NumberFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.NumberFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaces();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 places = 1;
 * @return {number}
 */
proto.worklayer.internal.v1.NumberFormat.prototype.getPlaces = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.NumberFormat} returns this
 */
proto.worklayer.internal.v1.NumberFormat.prototype.setPlaces = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.NumberFormat.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.NumberFormat} returns this
 */
proto.worklayer.internal.v1.NumberFormat.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SelectOption.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SelectOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SelectOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SelectOption}
 */
proto.worklayer.internal.v1.SelectOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SelectOption;
  return proto.worklayer.internal.v1.SelectOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SelectOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SelectOption}
 */
proto.worklayer.internal.v1.SelectOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SelectOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SelectOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SelectOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SelectOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SelectOption} returns this
 */
proto.worklayer.internal.v1.SelectOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.SelectOption.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SelectOption} returns this
 */
proto.worklayer.internal.v1.SelectOption.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.InputValue.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.InputValue.TypeCase = {
  TYPE_NOT_SET: 0,
  BOOL_VALUE: 1,
  TEXT_VALUE: 2,
  NUMERIC_VALUE: 3,
  SELECT_VALUE: 4,
  DATE_VALUE: 5,
  DOCUMENTS_VALUE: 6
};

/**
 * @return {proto.worklayer.internal.v1.InputValue.TypeCase}
 */
proto.worklayer.internal.v1.InputValue.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.InputValue.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.InputValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.InputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.InputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.InputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    boolValue: (f = msg.getBoolValue()) && proto.worklayer.internal.v1.BoolInputValue.toObject(includeInstance, f),
    textValue: (f = msg.getTextValue()) && proto.worklayer.internal.v1.TextInputValue.toObject(includeInstance, f),
    numericValue: (f = msg.getNumericValue()) && proto.worklayer.internal.v1.NumericInputValue.toObject(includeInstance, f),
    selectValue: (f = msg.getSelectValue()) && proto.worklayer.internal.v1.SelectInputValue.toObject(includeInstance, f),
    dateValue: (f = msg.getDateValue()) && proto.worklayer.internal.v1.DateInputValue.toObject(includeInstance, f),
    documentsValue: (f = msg.getDocumentsValue()) && proto.worklayer.internal.v1.DocumentsInputValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.InputValue}
 */
proto.worklayer.internal.v1.InputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.InputValue;
  return proto.worklayer.internal.v1.InputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.InputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.InputValue}
 */
proto.worklayer.internal.v1.InputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.BoolInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.BoolInputValue.deserializeBinaryFromReader);
      msg.setBoolValue(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.TextInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.TextInputValue.deserializeBinaryFromReader);
      msg.setTextValue(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.NumericInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.NumericInputValue.deserializeBinaryFromReader);
      msg.setNumericValue(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.SelectInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.SelectInputValue.deserializeBinaryFromReader);
      msg.setSelectValue(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.DateInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.DateInputValue.deserializeBinaryFromReader);
      msg.setDateValue(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.DocumentsInputValue;
      reader.readMessage(value,proto.worklayer.internal.v1.DocumentsInputValue.deserializeBinaryFromReader);
      msg.setDocumentsValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.InputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.InputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.InputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.InputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoolValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.BoolInputValue.serializeBinaryToWriter
    );
  }
  f = message.getTextValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.TextInputValue.serializeBinaryToWriter
    );
  }
  f = message.getNumericValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.NumericInputValue.serializeBinaryToWriter
    );
  }
  f = message.getSelectValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.SelectInputValue.serializeBinaryToWriter
    );
  }
  f = message.getDateValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.DateInputValue.serializeBinaryToWriter
    );
  }
  f = message.getDocumentsValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.DocumentsInputValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional BoolInputValue bool_value = 1;
 * @return {?proto.worklayer.internal.v1.BoolInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getBoolValue = function() {
  return /** @type{?proto.worklayer.internal.v1.BoolInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.BoolInputValue, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.BoolInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setBoolValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearBoolValue = function() {
  return this.setBoolValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasBoolValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TextInputValue text_value = 2;
 * @return {?proto.worklayer.internal.v1.TextInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getTextValue = function() {
  return /** @type{?proto.worklayer.internal.v1.TextInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.TextInputValue, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.TextInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setTextValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearTextValue = function() {
  return this.setTextValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasTextValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NumericInputValue numeric_value = 3;
 * @return {?proto.worklayer.internal.v1.NumericInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getNumericValue = function() {
  return /** @type{?proto.worklayer.internal.v1.NumericInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.NumericInputValue, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.NumericInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setNumericValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearNumericValue = function() {
  return this.setNumericValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasNumericValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SelectInputValue select_value = 4;
 * @return {?proto.worklayer.internal.v1.SelectInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getSelectValue = function() {
  return /** @type{?proto.worklayer.internal.v1.SelectInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SelectInputValue, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.SelectInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setSelectValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearSelectValue = function() {
  return this.setSelectValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasSelectValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DateInputValue date_value = 5;
 * @return {?proto.worklayer.internal.v1.DateInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getDateValue = function() {
  return /** @type{?proto.worklayer.internal.v1.DateInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.DateInputValue, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.DateInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setDateValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearDateValue = function() {
  return this.setDateValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasDateValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DocumentsInputValue documents_value = 6;
 * @return {?proto.worklayer.internal.v1.DocumentsInputValue}
 */
proto.worklayer.internal.v1.InputValue.prototype.getDocumentsValue = function() {
  return /** @type{?proto.worklayer.internal.v1.DocumentsInputValue} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.DocumentsInputValue, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.DocumentsInputValue|undefined} value
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
*/
proto.worklayer.internal.v1.InputValue.prototype.setDocumentsValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.worklayer.internal.v1.InputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.InputValue} returns this
 */
proto.worklayer.internal.v1.InputValue.prototype.clearDocumentsValue = function() {
  return this.setDocumentsValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.InputValue.prototype.hasDocumentsValue = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BoolInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BoolInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BoolInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BoolInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BoolInputValue}
 */
proto.worklayer.internal.v1.BoolInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BoolInputValue;
  return proto.worklayer.internal.v1.BoolInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BoolInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BoolInputValue}
 */
proto.worklayer.internal.v1.BoolInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BoolInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BoolInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BoolInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BoolInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.BoolInputValue.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.BoolInputValue} returns this
 */
proto.worklayer.internal.v1.BoolInputValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.TextInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.TextInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.TextInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.TextInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.TextInputValue}
 */
proto.worklayer.internal.v1.TextInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.TextInputValue;
  return proto.worklayer.internal.v1.TextInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.TextInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.TextInputValue}
 */
proto.worklayer.internal.v1.TextInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.TextInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.TextInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.TextInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.TextInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.TextInputValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.TextInputValue} returns this
 */
proto.worklayer.internal.v1.TextInputValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.NumericInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.NumericInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.NumericInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.NumericInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.NumericInputValue}
 */
proto.worklayer.internal.v1.NumericInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.NumericInputValue;
  return proto.worklayer.internal.v1.NumericInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.NumericInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.NumericInputValue}
 */
proto.worklayer.internal.v1.NumericInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.NumericInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.NumericInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.NumericInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.NumericInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional worklayer.shared.types.v1.Decimal value = 1;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.NumericInputValue.prototype.getValue = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 1));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.NumericInputValue} returns this
*/
proto.worklayer.internal.v1.NumericInputValue.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.NumericInputValue} returns this
 */
proto.worklayer.internal.v1.NumericInputValue.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.NumericInputValue.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.SelectInputValue.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.SelectInputValue.SelectionCase = {
  SELECTION_NOT_SET: 0,
  SINGLE: 1,
  MULTI: 2
};

/**
 * @return {proto.worklayer.internal.v1.SelectInputValue.SelectionCase}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.getSelectionCase = function() {
  return /** @type {proto.worklayer.internal.v1.SelectInputValue.SelectionCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.SelectInputValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SelectInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SelectInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    single: (f = msg.getSingle()) && proto.worklayer.internal.v1.SelectInputValue.Single.toObject(includeInstance, f),
    multi: (f = msg.getMulti()) && proto.worklayer.internal.v1.SelectInputValue.Multi.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SelectInputValue}
 */
proto.worklayer.internal.v1.SelectInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SelectInputValue;
  return proto.worklayer.internal.v1.SelectInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SelectInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SelectInputValue}
 */
proto.worklayer.internal.v1.SelectInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.SelectInputValue.Single;
      reader.readMessage(value,proto.worklayer.internal.v1.SelectInputValue.Single.deserializeBinaryFromReader);
      msg.setSingle(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.SelectInputValue.Multi;
      reader.readMessage(value,proto.worklayer.internal.v1.SelectInputValue.Multi.deserializeBinaryFromReader);
      msg.setMulti(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SelectInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SelectInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSingle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.SelectInputValue.Single.serializeBinaryToWriter
    );
  }
  f = message.getMulti();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.SelectInputValue.Multi.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SelectInputValue.Single.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SelectInputValue.Single.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Single} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.Single.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectedId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Single}
 */
proto.worklayer.internal.v1.SelectInputValue.Single.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SelectInputValue.Single;
  return proto.worklayer.internal.v1.SelectInputValue.Single.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Single} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Single}
 */
proto.worklayer.internal.v1.SelectInputValue.Single.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelectedId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SelectInputValue.Single.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SelectInputValue.Single.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Single} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.Single.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectedId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string selected_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SelectInputValue.Single.prototype.getSelectedId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Single} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.Single.prototype.setSelectedId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SelectInputValue.Multi.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Multi} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectedIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Multi}
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SelectInputValue.Multi;
  return proto.worklayer.internal.v1.SelectInputValue.Multi.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Multi} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Multi}
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SelectInputValue.Multi.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SelectInputValue.Multi} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectedIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string selected_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.getSelectedIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Multi} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.setSelectedIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Multi} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.addSelectedIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SelectInputValue.Multi} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.Multi.prototype.clearSelectedIdsList = function() {
  return this.setSelectedIdsList([]);
};


/**
 * optional Single single = 1;
 * @return {?proto.worklayer.internal.v1.SelectInputValue.Single}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.getSingle = function() {
  return /** @type{?proto.worklayer.internal.v1.SelectInputValue.Single} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SelectInputValue.Single, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.SelectInputValue.Single|undefined} value
 * @return {!proto.worklayer.internal.v1.SelectInputValue} returns this
*/
proto.worklayer.internal.v1.SelectInputValue.prototype.setSingle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.SelectInputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SelectInputValue} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.clearSingle = function() {
  return this.setSingle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.hasSingle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Multi multi = 2;
 * @return {?proto.worklayer.internal.v1.SelectInputValue.Multi}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.getMulti = function() {
  return /** @type{?proto.worklayer.internal.v1.SelectInputValue.Multi} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SelectInputValue.Multi, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.SelectInputValue.Multi|undefined} value
 * @return {!proto.worklayer.internal.v1.SelectInputValue} returns this
*/
proto.worklayer.internal.v1.SelectInputValue.prototype.setMulti = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.SelectInputValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SelectInputValue} returns this
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.clearMulti = function() {
  return this.setMulti(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SelectInputValue.prototype.hasMulti = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DateInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DateInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DateInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DateInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DateInputValue}
 */
proto.worklayer.internal.v1.DateInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DateInputValue;
  return proto.worklayer.internal.v1.DateInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DateInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DateInputValue}
 */
proto.worklayer.internal.v1.DateInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DateInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DateInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DateInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DateInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.DateInputValue.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.DateInputValue} returns this
*/
proto.worklayer.internal.v1.DateInputValue.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.DateInputValue} returns this
 */
proto.worklayer.internal.v1.DateInputValue.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.DateInputValue.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.DocumentsInputValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DocumentsInputValue.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DocumentsInputValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DocumentsInputValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectedDocumentsList: jspb.Message.toObjectList(msg.getSelectedDocumentsList(),
    proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue}
 */
proto.worklayer.internal.v1.DocumentsInputValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DocumentsInputValue;
  return proto.worklayer.internal.v1.DocumentsInputValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue}
 */
proto.worklayer.internal.v1.DocumentsInputValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry;
      reader.readMessage(value,proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.deserializeBinaryFromReader);
      msg.addSelectedDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DocumentsInputValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DocumentsInputValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DocumentsInputValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectedDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    linkedDocumentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry;
  return proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkedDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLinkedDocumentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry} returns this
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string linked_document_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.getLinkedDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry} returns this
 */
proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry.prototype.setLinkedDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DocumentsAnswerEntry selected_documents = 1;
 * @return {!Array<!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry>}
 */
proto.worklayer.internal.v1.DocumentsInputValue.prototype.getSelectedDocumentsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry>} value
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue} returns this
*/
proto.worklayer.internal.v1.DocumentsInputValue.prototype.setSelectedDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry}
 */
proto.worklayer.internal.v1.DocumentsInputValue.prototype.addSelectedDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.DocumentsInputValue.DocumentsAnswerEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.DocumentsInputValue} returns this
 */
proto.worklayer.internal.v1.DocumentsInputValue.prototype.clearSelectedDocumentsList = function() {
  return this.setSelectedDocumentsList([]);
};


goog.object.extend(exports, proto.worklayer.internal.v1);
